<wl-modal
  (closeModal)="dismissModal()"
  [modalTitle]="modalTitle?.value"
  trackImpression="contentblock-impression"
  [trackImpressionName]="modalTitle?.value"
>
  <ng-template wlModalBody>
    <wl-rich-text-wrapper wlAutomationId="wl-modal-body" [field]="modalMessage">
      <p class="text-small text-start ms-2 mb-0"></p>
    </wl-rich-text-wrapper>
  </ng-template>
</wl-modal>
